import { type FC } from 'react';

import mxpnl from '../../utils/analytics/mixpanel';
import phog from '../../utils/analytics/posthog/posthog';
import { BaseEventCard } from '../common/BaseEventCard';

import { type EventCardEventFragment } from './__generated-gql-types__/EventCard.generated';

interface EventCardProps {
  event: EventCardEventFragment;
  source?: string;
}

export const EventCard: FC<EventCardProps> = ({ event, source }) => {
  return (
    <BaseEventCard
      name={event.shindigName}
      categories={event.categories?.map((cat) => cat.category)}
      image={event.imageLink}
      isFree
      date={event.date}
      coaches={event.coaches}
      link={event.link}
      type={event.__typename}
      onButtonClick={() => {
        mxpnl.track('Click Event Card Register - Navigate to Luma', {
          name: event.shindigName,
          link: event.link,
        });
        phog.capture('event_card--navigate_to_luma_click', {
          name: event.shindigName,
          link: event.link,
        });
      }}
      totalAttendees={event.numGuests}
      attendeeFacePiles={event.guests
        ?.slice(0, 3)
        .map((guest) => ({ name: guest.name ?? '' }))}
      source={source}
    />
  );
};
